export default __webpack_public_path__ + "static/media/20.e5960078.jpg";